import { createContext, Dispatch } from 'react'

import { DataAction } from './actions'
import initialDataState from './initialState'
import { DataState } from './types'

export const DataContext = createContext<DataState | undefined>(initialDataState)
export const DataDispatchContext = createContext<Dispatch<DataAction> | undefined>(undefined)
